import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import FilterPanel from './components/FilterPanel';
import ProductGrid from './components/ProductGrid';
import { useCart } from '../../context/CartContext';

const ProductCatalog = () => {
  const location = useLocation();
  const { addToCart } = useCart();
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cartNotification, setCartNotification] = useState(null);

  const [filters, setFilters] = useState({
    category: 'all',
    sortBy: 'popular',
    priceRange: { min: '', max: '' },
    dosage: 'all',
    brand: 'all',
    inStock: false,
    preOrder: false,
    applications: {
      muscleGrowth: false,
      recovery: false,
      antiAging: false,
      cognitive: false
    }
  });

  const allProducts = [
  {
    id: 1,
    name: "Tirzepatide 10mg",
    category: "Weight Management",
    price: 73.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 50,
    rating: 4.9,
    reviews: 156,
    isNew: true,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_105b5701b-1770505605709.png",
    imageAlt: "Tirzepatide 10mg peptide vial for weight management and blood sugar regulation"
  },
  {
    id: 2,
    name: "Tirzepatide 15mg",
    category: "Weight Management",
    price: 109.00,
    originalPrice: null,
    dosage: "15mg",
    brand: "INF LABS",
    stock: 45,
    rating: 4.9,
    reviews: 142,
    isNew: true,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ba759436-1770505605640.png",
    imageAlt: "Tirzepatide 15mg peptide vial for advanced weight management"
  },
  {
    id: 3,
    name: "Tirzepatide 20mg",
    category: "Weight Management",
    price: 146.00,
    originalPrice: null,
    dosage: "20mg",
    brand: "INF LABS",
    stock: 38,
    rating: 4.8,
    reviews: 98,
    isNew: false,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_162a4e376-1770505605879.png",
    imageAlt: "Tirzepatide 20mg peptide vial for weight loss and metabolic health"
  },
  {
    id: 4,
    name: "Tirzepatide 30mg",
    category: "Weight Management",
    price: 250.00,
    originalPrice: null,
    dosage: "30mg",
    brand: "INF LABS",
    stock: 32,
    rating: 4.9,
    reviews: 87,
    isNew: false,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac1da7ef-1770505604694.png",
    imageAlt: "Tirzepatide 30mg peptide vial for maximum weight management support"
  },
  {
    id: 5,
    name: "Tirzepatide 60mg",
    category: "Weight Management",
    price: 437.00,
    originalPrice: null,
    dosage: "60mg",
    brand: "INF LABS",
    stock: 25,
    rating: 4.9,
    reviews: 64,
    isNew: true,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1592ac306-1770505606489.png",
    imageAlt: "Tirzepatide 60mg peptide vial for comprehensive metabolic support"
  },
  {
    id: 6,
    name: "Retatrutide (Reta) 6mg",
    category: "Weight Management",
    price: 46.00,
    originalPrice: null,
    dosage: "6mg",
    brand: "INF LABS",
    stock: 60,
    rating: 4.8,
    reviews: 112,
    isNew: true,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17d15b47e-1770505604842.png",
    imageAlt: "Retatrutide 6mg peptide vial with triple-action weight management formula"
  },
  {
    id: 7,
    name: "Retatrutide (Reta) 10mg",
    category: "Weight Management",
    price: 77.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 55,
    rating: 4.9,
    reviews: 134,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea9a56fd-1770505606785.png",
    imageAlt: "Retatrutide 10mg peptide vial for metabolic health enhancement"
  },
  {
    id: 8,
    name: "Retatrutide (Reta) 12mg",
    category: "Weight Management",
    price: 92.00,
    originalPrice: null,
    dosage: "12mg",
    brand: "INF LABS",
    stock: 48,
    rating: 4.8,
    reviews: 89,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18c5b4771-1770505606084.png",
    imageAlt: "Retatrutide 12mg peptide vial for advanced weight management"
  },
  {
    id: 9,
    name: "Retatrutide (Reta) 20mg",
    category: "Weight Management",
    price: 140.00,
    originalPrice: null,
    dosage: "20mg",
    brand: "INF LABS",
    stock: 42,
    rating: 4.9,
    reviews: 76,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d5c8882-1770505606480.png",
    imageAlt: "Retatrutide 20mg peptide vial for potent metabolic support"
  },
  {
    id: 10,
    name: "Retatrutide (Reta) 24mg",
    category: "Weight Management",
    price: 184.00,
    originalPrice: null,
    dosage: "24mg",
    brand: "INF LABS",
    stock: 35,
    rating: 4.8,
    reviews: 68,
    isNew: true,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1486a5da7-1770505607312.png",
    imageAlt: "Retatrutide 24mg peptide vial for comprehensive weight management"
  },
  {
    id: 11,
    name: "Retatrutide (Reta) 30mg",
    category: "Weight Management",
    price: 170.00,
    originalPrice: null,
    dosage: "30mg",
    brand: "INF LABS",
    stock: 30,
    rating: 4.9,
    reviews: 54,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ba7c41f3-1770505605822.png",
    imageAlt: "Retatrutide 30mg peptide vial for maximum metabolic health"
  },
  {
    id: 12,
    name: "Retatrutide (Reta) 48mg",
    category: "Weight Management",
    price: 367.00,
    originalPrice: null,
    dosage: "48mg",
    brand: "INF LABS",
    stock: 22,
    rating: 4.9,
    reviews: 41,
    isNew: true,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dbc0cba8-1770505605861.png",
    imageAlt: "Retatrutide 48mg peptide vial for intensive weight management"
  },
  {
    id: 13,
    name: "Retatrutide (Reta) 60mg",
    category: "Weight Management",
    price: 252.00,
    originalPrice: null,
    dosage: "60mg",
    brand: "INF LABS",
    stock: 18,
    rating: 4.8,
    reviews: 37,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14720f1a6-1770505604515.png",
    imageAlt: "Retatrutide 60mg peptide vial for comprehensive metabolic support"
  },
  {
    id: 14,
    name: "BPC-157 10mg",
    category: "Recovery & Healing",
    price: 32.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 75,
    rating: 4.9,
    reviews: 203,
    isNew: false,
    keyBenefits: "Accelerates tissue & wound healing • Reduces inflammation • Supports gut health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12d63bcd9-1764699716363.png",
    imageAlt: "BPC-157 10mg peptide vial for tissue repair and gut health"
  },
  {
    id: 15,
    name: "GHK-Cu 100mg",
    category: "Recovery & Healing",
    price: 77.00,
    originalPrice: null,
    dosage: "100mg",
    brand: "INF LABS",
    stock: 40,
    rating: 4.8,
    reviews: 145,
    isNew: true,
    keyBenefits: "Skin rejuvenation & collagen synthesis • Supports wound healing • Antioxidant properties",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_102cf597c-1770505610477.png",
    imageAlt: "GHK-Cu 100mg peptide vial for skin rejuvenation and collagen support"
  },
  {
    id: 16,
    name: "Tesamorelin 10mg",
    category: "Performance Enhancement",
    price: 88.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 33,
    rating: 4.7,
    reviews: 92,
    isNew: false,
    keyBenefits: "Stimulates growth hormone release • May reduce visceral fat • Supports muscle recovery",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Tesamorelin 10mg peptide vial for growth hormone stimulation"
  },
  {
    id: 17,
    name: "CJC-1295 / Ipamorelin Blend 10mg",
    category: "Performance Enhancement",
    price: 59.00,
    originalPrice: null,
    dosage: "10mg total",
    brand: "INF LABS",
    stock: 58,
    rating: 4.9,
    reviews: 178,
    isNew: true,
    keyBenefits: "Promotes fat loss & muscle gain • Supports recovery & sleep quality • Selective GH release",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "CJC-1295 Ipamorelin blend peptide vial for muscle gain and recovery"
  },
  {
    id: 18,
    name: "PT-141 10mg",
    category: "Performance Enhancement",
    price: 44.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 52,
    rating: 4.7,
    reviews: 124,
    isNew: false,
    keyBenefits: "Libido enhancement in both sexes • Non-hormonal mechanism • Acts centrally in the brain",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1151f3b4f-1770505606283.png",
    imageAlt: "PT-141 10mg peptide vial for libido enhancement"
  },
  {
    id: 19,
    name: "Sermorelin 5mg",
    category: "Performance Enhancement",
    price: 44.00,
    originalPrice: null,
    dosage: "5mg",
    brand: "INF LABS",
    stock: 67,
    rating: 4.8,
    reviews: 156,
    isNew: false,
    keyBenefits: "Stimulates natural GH production • Anti-aging & recovery support • Well-tolerated profile",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Sermorelin 5mg peptide vial for natural growth hormone production"
  },
  {
    id: 20,
    name: "BPC-157 / TB-4 Blend 20mg",
    category: "Recovery & Healing",
    price: 108.00,
    originalPrice: null,
    dosage: "20mg total",
    brand: "INF LABS",
    stock: 28,
    rating: 4.9,
    reviews: 187,
    isNew: true,
    keyBenefits: "Synergistic healing & repair • Reduces inflammation • Supports muscle, tendon, gut health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_136b5df99-1764679627518.png",
    imageAlt: "BPC-157 TB-4 blend peptide vial for comprehensive healing support"
  },
  {
    id: 21,
    name: "GHK-Cu / KPV Blend 70mg",
    category: "Recovery & Healing",
    price: 257.00,
    originalPrice: null,
    dosage: "70mg total",
    brand: "INF LABS",
    stock: 15,
    rating: 4.8,
    reviews: 73,
    isNew: true,
    keyBenefits: "Skin rejuvenation & anti-inflammatory • Topical cosmetic benefits • Promotes collagen, reduces redness",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c8a33c58-1770505604343.png",
    imageAlt: "GHK-Cu KPV blend peptide vial for skin rejuvenation and anti-inflammatory support"
  },
  {
    id: 22,
    name: "Semax 10mg",
    category: "Cognitive Enhancement",
    price: 42.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 44,
    rating: 4.7,
    reviews: 98,
    isNew: false,
    keyBenefits: "Cognitive enhancement & neuroprotection • May improve mood & focus • Supports brain recovery",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12f47cced-1770507220091.png",
    imageAlt: "Semax 10mg peptide vial for cognitive enhancement and neuroprotection"
  },
  {
    id: 23,
    name: "Ipamorelin 10mg",
    category: "Performance Enhancement",
    price: 59.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 61,
    rating: 4.9,
    reviews: 167,
    isNew: false,
    keyBenefits: "Selective GH secretagogue • Supports recovery & body composition • Minimal impact on cortisol",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Ipamorelin 10mg peptide vial for selective growth hormone release"
  },
  {
    id: 24,
    name: "Selank 10mg",
    category: "Cognitive Enhancement",
    price: 41.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 50,
    rating: 4.6,
    reviews: 82,
    isNew: false,
    keyBenefits: "May reduce anxiety & stress • Supports cognitive function • Potential nootropic effects",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a5e1b0ee-1770505604688.png",
    imageAlt: "Selank 10mg peptide vial for anxiety reduction and cognitive support"
  },
  {
    id: 25,
    name: "AOD-9604 2mg",
    category: "Weight Management",
    price: 27.00,
    originalPrice: null,
    dosage: "2mg",
    brand: "INF LABS",
    stock: 70,
    rating: 4.7,
    reviews: 115,
    isNew: false,
    keyBenefits: "May stimulate fat metabolism • Supports weight loss • Derived from GH fragment",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b01e08d-1770505606100.png",
    imageAlt: "AOD-9604 2mg peptide vial for fat metabolism and weight loss support"
  },
  {
    id: 26,
    name: "Melanotan II 10mg",
    category: "Performance Enhancement",
    price: 45.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 38,
    rating: 4.5,
    reviews: 94,
    isNew: false,
    keyBenefits: "Promotes skin tanning • May enhance libido • Can suppress appetite",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_105ce3fbf-1766470445165.png",
    imageAlt: "Melanotan II 10mg peptide vial for tanning and appetite suppression"
  }];


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params?.get('category');
    const search = params?.get('search');

    if (category) {
      setFilters((prev) => ({ ...prev, category }));
    }

    if (search) {





      // Search functionality would filter products here
    }setTimeout(() => setLoading(false), 1000);}, [location?.search]);useEffect(() => {
    if (isMobileFilterOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileFilterOpen]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      category: 'all',
      sortBy: 'popular',
      priceRange: { min: '', max: '' },
      dosage: 'all',
      brand: 'all',
      inStock: false,
      preOrder: false,
      applications: {
        muscleGrowth: false,
        recovery: false,
        antiAging: false,
        cognitive: false
      }
    });
  };

  const handleAddToCart = (product) => {
    // Add product to cart with quantity 1
    addToCart(product, 1);

    // Show notification
    setCartNotification({
      name: product?.name,
      price: product?.price
    });

    setTimeout(() => {
      setCartNotification(null);
    }, 3000);
  };

  const getFilteredProducts = () => {
    let filtered = [...allProducts];

    // Category filter
    if (filters?.category !== 'all') {
      filtered = filtered?.filter((p) =>
      p?.category?.toLowerCase()?.replace(/\s+/g, '-') === filters?.category
      );
    }

    // Price range filter
    if (filters?.priceRange?.min !== '') {
      filtered = filtered?.filter((p) => p?.price >= parseFloat(filters?.priceRange?.min));
    }
    if (filters?.priceRange?.max !== '') {
      filtered = filtered?.filter((p) => p?.price <= parseFloat(filters?.priceRange?.max));
    }

    // Dosage filter
    if (filters?.dosage !== 'all') {
      filtered = filtered?.filter((p) => p?.dosage === filters?.dosage);
    }

    // Brand filter
    if (filters?.brand !== 'all') {
      filtered = filtered?.filter((p) =>
      p?.brand?.toLowerCase()?.replace(/\s+/g, '-') === filters?.brand
      );
    }

    // Stock filter
    if (filters?.inStock) {
      filtered = filtered?.filter((p) => p?.stock > 0);
    }

    // Sort
    switch (filters?.sortBy) {
      case 'price-low':
        filtered?.sort((a, b) => a?.price - b?.price);
        break;
      case 'price-high':
        filtered?.sort((a, b) => b?.price - a?.price);
        break;
      case 'newest':
        filtered?.sort((a, b) => b?.isNew - a?.isNew);
        break;
      case 'name-asc':
        filtered?.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case 'name-desc':
        filtered?.sort((a, b) => b?.name?.localeCompare(a?.name));
        break;
      default:
        filtered?.sort((a, b) => b?.rating - a?.rating);
    }

    return filtered;
  };

  const filteredProducts = getFilteredProducts();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 md:pt-24 lg:pt-28">
        {/* Hero Section */}
        <section className="relative overflow-hidden py-8 md:py-12 lg:py-16 px-4 md:px-6 lg:px-8"
        style={{
          background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%)'
        }}>
          <div className="max-w-7xl mx-auto">
            <div className="text-center space-y-3 md:space-y-4 lg:space-y-6">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold gradient-text">
                Premium Peptide Catalog
              </h1>
              <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
                Discover our extensive collection of research-grade peptides for performance enhancement, recovery, and cognitive optimization
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-6 md:py-8 lg:py-12 px-4 md:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
              {/* Mobile Filter Button */}
              <div className="lg:hidden">
                <Button
                  variant="outline"
                  fullWidth
                  iconName="SlidersHorizontal"
                  iconPosition="left"
                  onClick={() => setIsMobileFilterOpen(true)}>
                  
                  Filters & Sort
                </Button>
              </div>

              {/* Filter Sidebar */}
              <aside className="lg:w-80 flex-shrink-0">
                <FilterPanel
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  onClearFilters={handleClearFilters}
                  productCount={filteredProducts?.length}
                  isMobileFilterOpen={isMobileFilterOpen}
                  onCloseMobileFilter={() => setIsMobileFilterOpen(false)} />
                
              </aside>

              {/* Product Grid */}
              <div className="flex-1 min-w-0">
                <ProductGrid
                  products={filteredProducts}
                  onAddToCart={handleAddToCart}
                  loading={loading} />
                
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* Cart Notification */}
      {cartNotification &&
      <div
        className="fixed bottom-4 md:bottom-6 right-4 md:right-6 z-[1040] p-4 md:p-6 rounded-xl shadow-2xl max-w-sm animate-slide-up"
        style={{
          background: 'var(--color-card)',
          border: '1px solid var(--color-border)'
        }}>
        
          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{
            background: 'linear-gradient(135deg, var(--color-success) 0%, var(--color-primary) 100%)'
          }}>
              <Icon name="Check" size={20} color="#FFFFFF" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">Added to Cart</h4>
              <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">{cartNotification?.name}</p>
              <p className="text-sm md:text-base font-bold text-primary mt-1">${cartNotification?.price?.toFixed(2)}</p>
            </div>
          </div>
        </div>
      }
      {/* Mobile Filter Overlay */}
      {isMobileFilterOpen &&
      <div
        className="fixed inset-0 bg-black/50 z-[1025] lg:hidden"
        onClick={() => setIsMobileFilterOpen(false)} />

      }
    </div>);

};

export default ProductCatalog;